import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Card, CardBody } from '../Card';
import { Avatar } from '../Avatar';
import { CtaButton } from '../CtaButton';
import { Reveal } from '../Reveal';
import { IMAGES } from '../../lib/content';
const CASES = [{
  name: 'Marisol R. · Atlanta, GA · Single arch · $20,000',
  person: 'Marisol R.',
  img: IMAGES.caseA,
  quote: 'I came to Pler after a year of searching and three cheaper quotes. What sold me was seeing my smile designed on my own face before I paid anything. Today, eight months later, I keep discovering in the mirror that the smile is mine, not from a catalog. Traveling from Atlanta was worth every dollar.'
}, {
  name: 'Robert T. · Nashville, TN · Full mouth package consultation, single arch scheduled',
  person: 'Robert T.',
  img: IMAGES.caseB,
  quote: 'What I feared most was the pain and being stuck with a removable denture for months. The sedation surgery was something else. On Day 5 I left with the final zirconia in place. The back and forth trips were over.'
}, {
  name: 'Diane K. · Charlotte, NC · Single arch · $20,000',
  person: 'Diane K.',
  img: IMAGES.caseC,
  quote: 'I bought one arch. I paid $20,000, which was $4,000 more than the $13K offer I saw in North Carolina. The difference is that my smile looks like mine. The other clinic showed me a generic catalog. I would pay those $4,000 again without thinking.'
}];
export function Testimonials() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-284" data-mp="26l3m563tarde">
      <div className="mx-auto max-w-6xl px-6" data-id="element-285" data-mp="22hxje8fwribo">
        <SectionHeading title="What changes after Day 5." data-id="element-286" data-mp="22gvylc93bhgr">
          <p data-id="element-287" data-mp="1xikl8rjl6ots">More confidence in photos, meals, conversations, and every moment you used to avoid.</p>
        </SectionHeading>
        <p className="mx-auto mt-5 max-w-3xl text-center text-sm italic leading-relaxed text-[#1A1A2E]/60" data-id="element-288" data-mp="r54tl36oh3y9">
          Each story below is a verified patient case on file at Pler Smile Dadeland. Names and minor identifying details are unmodified for these patients.
        </p>
        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-289" data-mp="sjo2mmz6wt0t">
          {CASES.map((c, i) => <Reveal key={c.name} delay={i * 0.08} className="h-full" data-id="element-290" data-mp="ek66tnnh8fhy" data-mpi={i}>
            <Card className="h-full transition duration-300 ease-out hover:-translate-y-1 hover:shadow-lg" data-id="element-291" data-mp="im055pa797ey">
              <CardBody className="flex h-full flex-col" data-id="element-292" data-mp="4uv0u9vvzqya">
                <div className="mb-4 flex items-center gap-3" data-id="element-293" data-mp="4tbjsh2epbvg">
                  <Avatar src={c.img} name={c.person} size="lg" data-id="element-294" data-mp="9mmtcpyls6r2" />
                  <div className="text-sm font-semibold text-[#1A1A2E]" data-id="element-295" data-mp="3r2uxwbxa9bfb">{c.name}</div>
                </div>
                <div className="mb-3 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-296" data-mp="3w0o3b2qri1ej">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} size={16} className="fill-teal text-teal" data-id="element-297" data-mp="3i2zgvqh1qm7d" data-mpi={i} />)}
                </div>
                <blockquote className="text-[15px] leading-relaxed text-[#1A1A2E]/80" data-id="element-298" data-mp="3n081rytkx4cb">&ldquo;{c.quote}&rdquo;</blockquote>
              </CardBody>
            </Card>
            </Reveal>)}
        </div>
        <div className="mt-10 flex flex-col items-center" data-id="element-299" data-mp="2yhpjhvv0m1fp">
          <CtaButton label="Reserve My Free Consultation" data-id="element-300" data-mp="3cfw8snlwet3r" />
          <p className="mt-3 text-sm font-medium text-[#1A1A2E]/70" data-id="element-301" data-mp="3cdb5du5yc53w">You see your options before making any decision.</p>
        </div>
      </div>
    </section>;
}